import { Users, ShieldCheck, FileKey } from "lucide-react";
import SectionLayout from "../../lib/components/SectionLayout";
import { getCompanyDisplayName } from "../../lib/utils/featureAccess";

const ADMIN_TABS = [
  { to: "/admin", label: "Users", icon: Users, exact: true },
  { to: "/admin/roles", label: "Roles", icon: ShieldCheck },
  { to: "/admin/policies", label: "Policies", icon: FileKey },
];

export default function AdminSection() {
  const companyName = getCompanyDisplayName();

  return (
    <SectionLayout
      companyName={companyName}
      title="Administration"
      subtitle="Manage users, roles & policies"
      tabs={ADMIN_TABS}
    />
  );
}
